module.exports = __webpack_public_path__ + "static/media/small.97063f98.svg";